import httpClient from '@/http-client'

export const get = (Options = {}) => {
	return httpClient
		.get("/api/v1/smg-activity-logs", Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
	return httpClient
		.get(`/api/v1/smg-activity-logs/form-view-models`, Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export default {
	get,
	formViewModel,
}